import { Avatar } from "@/features/common/components/Avatar";

export const ModelInfoListSkeleton = () => {
  return (
    <>
      {Array.from(Array(3)).map((_, index) => (
        <div className="flex animate-pulse items-center space-x-4" key={index}>
          <Avatar size="lg" />
          <div className="flex-1 space-y-3">
            <div className="h-4 w-1/2 rounded bg-slate-200"></div>
            <div className="flex space-x-3 text-sm">
              <div className="h-4 w-1/2 rounded bg-slate-200"></div>
              <div className="h-4 w-1/2 rounded bg-slate-200"></div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
